import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import * as S from "./style";
import * as Constant from "constant";
import TextInput from "./TextInput";
import Chip from "components/common/Chip";
import InfoCard from "../InfoCard";

ChipInput.propTypes = {
  placeholder: PropTypes.string,
  chipItems: PropTypes.arrayOf(PropTypes.object), //an item of a chip is an object: {label: 'jobs powerlink', value: 'jobs@powerlink.co.il', isValid: true/false}
  validator: PropTypes.func,
  onChange: PropTypes.func,
  selectedValue: PropTypes.string,
  size: PropTypes.oneOf([
    Constant.SIZE.xs,
    Constant.SIZE.small,
    Constant.SIZE.large,
  ]),
  color: PropTypes.oneOf([
    Constant.COLOR.primary,
    Constant.COLOR.secondary,
    Constant.COLOR.success,
    Constant.COLOR.danger,
    Constant.COLOR.badge,
    Constant.COLOR.light,
    Constant.COLOR.dark,
  ]),
  variant: PropTypes.oneOf([
    Constant.VARIENT.contained,
    Constant.VARIENT.outlined,
  ]),
};

ChipInput.defaultProps = {
  chipItems: [],
  color: Constant.COLOR.light,
  variant: Constant.VARIENT.contained,
};

const KEY_CODE_NAME = {
  backspace: 8,
  enter: 13,
};

const getListOnRemovedItem = (list) => {
  let newList = list.slice();
  return newList;
};

function ChipInput(props) {
  const [chipItemsList, setChipItemsList] = useState(props.chipItems);
  const [chipValue, setChipValue] = useState("");

  useEffect(() => {
    setChipItemsList(props.chipItems);
    setChipValue({ label: "", value: "", isValid: true });
  }, [props.chipItems]);

  useEffect(() => {
    if (props.selectedValue.length) {
      setChipValue({ label: "", value: "", isValid: true });
    }
  }, [props.selectedValue]);

  const handleKeyDown = (e) => {
    switch (e.keyCode) {
      case KEY_CODE_NAME.backspace:
        handleBackspaceClicked();
        break;
      case KEY_CODE_NAME.enter:
        handleEnterClicked();
        break;
      default:
        break;
    }
  };

  const handleOnBlur = () => {
    setChip();
  };

  const handleEnterClicked = () => {
    handleOnKeyUp();
    setChip();
  };

  const setChip = () => {
    if (chipValue && chipValue.value.replace(/\s/g, "").length) {
      if (props.validator) {
        const isValid = props.validator(chipValue.value);
        chipValue.isValid = isValid;
      }
      chipItemsList.push(chipValue);
      setChipValue({ label: "", value: "", isValid: true });
      if (props.onChange) {
        props.onChange([...chipItemsList], chipValue);
      }
    }
  };

  const handleBackspaceClicked = () => {
    if (chipValue.value.length === 0 && chipItemsList.length > 0) {
      const index = chipItemsList.length - 1;
      chipItemsList.splice(index, 1);
      if (props.onChange) {
        props.onChange(getListOnRemovedItem(chipItemsList, index));
      }
    }
  };

  const handleOnChange = (str) => {
    setChipValue({ label: str, value: str, isValid: true });
  };

  const handleDeleteChipClick = (index) => {
    chipItemsList.splice(index, 1);
    if (props.onChange) {
      props.onChange(getListOnRemovedItem(chipItemsList, index));
    }
  };

  const handleOnKeyUp = (event) => {
    if (props.onKeyUp) {
      event ? props.onKeyUp(event.target.value) : props.onKeyUp("");
    }
  };

  return (
    <S.BaseChipInput>
      <S.ChipContainer>
        {chipItemsList ? (
          chipItemsList.map((item, i) => {
            if (item.isValid) {
              return (
                <Chip
                  key={i}
                  label={item.label}
                  size={props.size}
                  color={props.color}
                  variant={props.variant}
                  onDeleteButtonClick={() => handleDeleteChipClick(i)}
                  hoverElement={
                    <InfoCard
                      primaryText={item.label}
                      secondaryText={[item.value]}
                    ></InfoCard>
                  }
                />
              );
            } else {
              return (
                <Chip
                  key={i}
                  label={item.label}
                  size={props.size}
                  color={Constant.COLOR.danger}
                  variant={props.variant}
                  onDeleteButtonClick={() => handleDeleteChipClick(i)}
                />
              );
            }
          })
        ) : (
          <></>
        )}
        <S.TextInputContainer>
          <TextInput
            onKeyDown={handleKeyDown}
            onKeyUp={handleOnKeyUp}
            placeholder={props.placeholder}
            variant={Constant.VARIENT.empty}
            onChange={handleOnChange}
            value={chipValue.value}
            onBlur={handleOnBlur}
          />
        </S.TextInputContainer>
      </S.ChipContainer>
    </S.BaseChipInput>
  );
}

export default ChipInput;
